import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface AlertState {
  isOpen: boolean;
  canClose?: boolean;
  title?: string;
  message?: string;
  variant?: "success" | "warning" | "destructive";
  buttons: {
    label: string;
    value: string;
    variant?: "success" | "warning" | "destructive" | "default";
  }[];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resolve: ((value?: any) => void) | null; // Use `any` for generic compatibility
  showDialog: <T extends string>(options: {
    title?: string;
    message?: string;
    variant?: "success" | "warning" | "destructive";
    canClose?: boolean;
    buttons: {
      label: string;
      value: T;
      variant?: "success" | "warning" | "destructive" | "default";
    }[];
  }) => Promise<T | undefined>;
  closeDialog: (result?: string) => void;
}

export const useAlertStore = create<AlertState>()(
  devtools((set) => ({
    isOpen: false,
    title: undefined,
    message: undefined,
    variant: undefined,
    buttons: [],
    resolve: null,
    showDialog: ({ title, canClose, message, variant, buttons }) =>
      new Promise((resolve) => {
        set({
          isOpen: true,
          message,
          canClose,
          title,
          variant,
          resolve,
          buttons,
        });
      }),
    closeDialog: (result) => {
      set((state) => {
        if (state.resolve) {
          state.resolve(result);
        }
        return {
          isOpen: false,
          title: undefined,
          message: undefined,
          variant: undefined,
          buttons: [],
          resolve: null,
        };
      });
    },
  })),
);
